import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductBasketStore } from './product-basket.store';

export const selectProductBasketStore = createFeatureSelector<ProductBasketStore>('productBasket');

// ==================== DATA SELECTORS ====================
export const selectBasketId = createSelector(
  selectProductBasketStore,
  (state) => state.id
);

export const selectBasketProducts = createSelector(
  selectProductBasketStore,
  (state) => state.basketProducts
);

export const selectIsPunchOutBasket = createSelector(
  selectProductBasketStore,
  (state) => state.isPunchOutBasket
);

export const selectBasketProductCount = createSelector(
  selectBasketProducts,
  (basketProducts) => basketProducts.reduce((total, basketProduct) => total + basketProduct.quantity, 0)
);

export const selectBasketTotal = createSelector(
  selectBasketProducts,
  (basketProducts) => basketProducts.reduce((total, basketProduct) => total + (basketProduct.customerPriceExVat * basketProduct.quantity), 0)
);

// ==================== LOADING SELECTOR ====================
export const selectBasketLoading = createSelector(
  selectProductBasketStore,
  (state) => state.loading
);

// ==================== ERROR SELECTOR ====================
export const selectBasketError = createSelector(
  selectProductBasketStore,
  (state) => state.error
);
